import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class CuentasService {
  url = `${this.env.URL_API}/cuenta`;

  constructor(public http: HttpClient, private env: EnvService) { }

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  crear(body): Observable<any> {
    return this.http.post(`${this.url}`, body);
  }
  actualizar(body): Observable<any> {
    return this.http.put(`${this.url}/${body.id_cuentas}`, body);
  }
  obtenerTodos(): Observable<any> {
    return this.http.get(`${this.url}`, { headers: this.headers });
  }
  obtenerId(id): Observable<any> {
    return this.http.get(`${this.url}/${id}`);
  }
  eliminar(id): Observable<any> {
    const body = { body: { id_usuarios_creador: sessionStorage.getItem('id_usuario') }, headers: this.headers };
    return this.http.delete(`${this.url}/${id}`, body);
  }
}
